import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../ui/Typography';
import { fontWeight } from '../../styled/constants';
import { TooltipContainer, TooltipWrapper } from './styled';

const Tooltip = ({
  text,
  children,
  wrapperWidth,
  wrapperHeight,
  tooltipTopSpace
}) => {
  const [visible, setVisible] = useState(false);

  const handleMouseEnter = () => {
    setVisible(true);
  };
  const handleMouseLeave = () => {
    setVisible(false);
  };

  return (
    <TooltipWrapper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...{ wrapperWidth, wrapperHeight }}
    >
      {children}
      <TooltipContainer
        visible={visible}
        data-cy="tooltip"
        {...{ tooltipTopSpace }}
      >
        <Typography
          tag="caption_2"
          styles={{ fontWeight: fontWeight.thin, fontSize: '15px' }}
        >
          {text}
        </Typography>
      </TooltipContainer>
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
  wrapperWidth: PropTypes.number.isRequired,
  wrapperHeight: PropTypes.number.isRequired,
  tooltipTopSpace: PropTypes.number.isRequired
};

export default Tooltip;
